import { render, staticRenderFns } from "./BacklogItem.vue?vue&type=template&id=22a6e0c0"
import script from "./BacklogItem.vue?vue&type=script&lang=js"
export * from "./BacklogItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports